import Form from "./form";
import { AttendanceLocalDepartmentGuiche } from "../../../../../../../../../../../../../@types/attendance-local-department-guiche";
import { useAttendanceLocalDepartmentGuicheServiceCreate } from "../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/guiche/service/create";
import { AttendanceLocalDepartment } from "../../../../../../../../../../../../../@types/attendance-local-department";

type Props = {
    unidade_slug: string;
    setor_unidade: AttendanceLocalDepartment["id"];
    guiche_id: AttendanceLocalDepartmentGuiche["id"];
    buttonTrigger?: React.ReactNode;
};

export default function FormCreate(props: Props) {
    const mutation = useAttendanceLocalDepartmentGuicheServiceCreate();

    return (
        <Form
            {...props}
            mutation={mutation}
        />
    );
}
